var GET_STARTED_ANCHORS = {
    faq: 'faq',
};
export { GET_STARTED_ANCHORS };
